import { FreedataCall, IncExKeyCmd, IncExcKeyVO } from '@wizeoo/akm-common-lib';
import { Component, ElementRef, ViewChild } from '@angular/core';
import { WIZ_EVENT_TYPE, CONFIRMATION_MODE, CONFIRMATION_RESULT } from '@wizeoo/akm-core-lib';
import {
  BATCH_FILE_FORMAT,
  ConfirmationResultObj,
  FilterComponent,
  WizAgGrid,
  WizDatasource,
  WizGroupCommand,
  WizIcon,
  WizPopUp,
  WizRoot,
  WizTileList,
  WizToggle,
  WizTranslationBasic,
  WizTree,
  WizEventManager, WizEvent
} from '@wizeoo/akm-component-lib';
import { ColDef } from 'ag-grid-community';
import { ChronocodeCmd } from '@wizeoo/akm-common-lib';
import { MultiDisplayConfig, MultiDisplay } from '@wizeoo/akm-common-lib';
import { AgActionDeleteRenderer } from '@wizeoo/akm-common-lib';
import { AlkEvent } from '@wizeoo/akm-common-lib';
import { ALK_EVENT_TYPE } from '@wizeoo/akm-common-lib';
import { Model } from 'src/app/model/model';
import { ViewData } from '@wizeoo/akm-common-lib';
import { IncExcContentObj } from '@wizeoo/akm-common-lib';
import { IncExcMainObj } from '@wizeoo/akm-common-lib';
import { BaseView } from '@wizeoo/akm-common-lib';
import { IncExcSamplePop } from './pop/incexc-sample.pop';
import { IncExcContentRenderer } from './renderer/incex-content.renderer';
import { IncExcKeyPartRenderer } from './renderer/incex-keypart.renderer';
import { IncExcKindRenderer } from './renderer/incex-kind.renderer';
import { IncExcTileRenderer } from './renderer/incex-tile.renderer';
import { IncExcWayRenderer } from './renderer/incex-way.renderer';
import { WidgetConfigurationObj, WidgetConfigurationItemObj } from '@wizeoo/akm-message-lib';
import { BATCH_KIND } from '@wizeoo/akm-common-lib';
import { WidgetLine } from '@wizeoo/akm-compute-lib';
import { PivotIncExcRenderer } from '@wizeoo/akm-common-lib';

/**
 * Vue de gestion des includes / excludes
 * Author LMA
 */
@Component({
  selector: 'incexc-view',
  templateUrl: './incexc.view.html',
})
export class IncExcView extends BaseView {
  @ViewChild('mdMain') mdMain: MultiDisplay<IncExcMainObj>; // grid principal
  @ViewChild('treeContent', { read: WizTree, static: false }) treeContent: WizTree<IncExcContentObj>; // contenus des objets Main, pour affectation
  @ViewChild('contentFilter', { read: FilterComponent, static: false }) contentFilter: FilterComponent; // filtre du grid de détail
  @ViewChild('tileKey') tileKey: WizTileList; // container des clés
  @ViewChild('mdInc') mdInc: WizAgGrid<IncExcKeyVO>; // grid des includes
   /** le composant de filtre des keys  */
   @ViewChild('keyFilter', { read: FilterComponent, static: false }) keyFilter: FilterComponent;
  
  @ViewChild('toggleInc', { read: WizToggle }) toggleInc: WizToggle; // toggleSwitch pour update
  @ViewChild('trsDesc', { read: WizTranslationBasic }) trsDesc: WizTranslationBasic; // description

  /** Renderer du tree si FDV */
  public contentRenderer: any = IncExcContentRenderer;

  /** Renderer de la clé en cours (collection de IncExcContentObj), générée par le  IncExcKeyVO */
  public currentKeyRenderer: any = IncExcKeyPartRenderer;

  /** Constructeur */
  constructor(public elementRef: ElementRef) {
    super(elementRef);
  }

  /** DS du grid principal */
  public mainDS: WizDatasource<IncExcMainObj> = new WizDatasource<IncExcMainObj>([])
    .setSortFields([{ property: 'label', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** Data source de l'arbre des éléments de contenu */
  public contentDS: WizDatasource<IncExcContentObj> = new WizDatasource<IncExcContentObj>([])
    .setHierarchical(true)
    .setItemCodeField('code')
    .setItemParentCodeField('parentCode')
    .setSortFields([{ property: 'label', way: 'asc', numeric: false }])
    .setFilter(this.contentFilterFunc.bind(this))
    .setSelectionMode('single')
    .build();

  /** DS de la clé en édition / construction */
  public currentKeyDS: WizDatasource<IncExcContentObj> = new WizDatasource<IncExcContentObj>([])
    .setSortFields([{ property: 'parentCode', way: 'asc', numeric: false }])
    .setSelectionMode('none')
    .build();

  /** Data source des clés */
  public keyDS: WizDatasource<IncExcKeyVO> = new WizDatasource<IncExcKeyVO>([])
    .setFilter(this.keyFilterFunc.bind(this))
    .setSortFields([{ property: 'key', way: 'asc', numeric: false }])
    .setSelectionMode('single')
    .build();

  /** Configuration du mode multi display (principal) */
  public mainConfig: MultiDisplayConfig<IncExcMainObj> = {
    model: Model.getInstance(),
    datasource: this.mainDS,
    defaultMode: 'tiles',
    onSelectionChanged: this.selectMain.bind(this),
    tiles: { enabled: true, renderer: IncExcTileRenderer, itemHeight: 80, itemWidth: 210 },
    grid: {
      enabled: true,
      columns: [
        { headerName: '$.common.kind.$', width: 40, sortable: true, field: 'kindStr', cellRenderer: 'kindRenderer' },
        { headerName: '$.common.code.$', width: 80, sortable: true, field: 'code', tooltipField: 'code' },
        { headerName: '$.common.label.$', flex: 1, sortable: true, field: 'label', tooltipField: 'label' },
      ],
      renderers: {
        kindRenderer: IncExcKindRenderer,
      },
    },
    filter: {
      enabled: true,
      initFilter: this.initMainFilter.bind(this),
    },
  };

  /**
   * Déclaration des renderer d'édition et de présentation.
   * L'ag-grid utilise ce fonctionnement pour référencer les composants de rendu
   */
   public keyGridComponents: any = {
    deleteRenderer: AgActionDeleteRenderer,
    wayRenderer: IncExcWayRenderer
  }

  // colonne du grid des roles du profil
  public keyGridColumns: ColDef[] = [
    { headerName: ' ', width: 30, field: 'id', cellRenderer: 'deleteRenderer' },
    { headerName: '$.common.kind.$', width: 40, sortable: true, field: 'incStr', cellRenderer: 'wayRenderer' },
    {
      headerName: '$.vision.title.$',
      width: 60,
      sortable: true,
      field: 'visionCodeStr',
      tooltipField: 'visionCodeStr',
    },
    // { headerName: '$.common.code.$', width: 200, sortable: true, field: 'key', tooltipField: 'key' },
    { headerName: '$.common.description.$', width: 200, sortable: true, field: 'trsDesc', tooltipField: 'trsDesc' },
    { headerName: '$.common.label.$', flex: 1, sortable: true, field: 'label', tooltipField: 'key' },
  ];


  public get hasCurrentKey(): boolean {
    // activation des zones de détail
    let hascur: boolean = !!Model.getInstance().incExcKeyEngine.currentKey;
    // console.log('hasCurrentKey', hascur);
    return !!Model.getInstance().incExcKeyEngine.currentKey;
  }

  public get hasUpdate(): boolean {
    // activation du cancel
    return ViewData.wizUpdateModel;
  }

  public get maySave(): boolean {
    // une modif en cours, et saisie valable
    if (!ViewData.wizUpdateModel) {
      return false;
    }
    if (
      !Model.getInstance().incExcKeyEngine.currentClone ||
      !Model.getInstance().incExcKeyEngine.currentClone.parts ||
       Model.getInstance().incExcKeyEngine.currentClone.parts.length < 1
    ) {
      // pas assez d'éléments
      return false;
    }
    return true;
  }

  /* #############################################################
                      CYCLE DE VIE
     ############################################################# */

  /**
   * Pretraitement: chargement des données nécessaires à la vue
   * @return WizGroupCommand
   */
  public wizBeforeInit(): WizGroupCommand {
    const commands = [];
    // disponibilité des chronocodes pour labels
    if (!Model.getInstance().chronocodeEngine.getChronocodesMap()) {
      commands.push(new ChronocodeCmd(Model.getInstance()).find());
    }

    // disponibilité des freedatas pour labels
    if (!Model.getInstance().freedataEngine.getFreedataMap()) {
      commands.push(new FreedataCall(Model.getInstance()));
    }

    // vérification des measures
    // if (!Model.getInstance().measureList) {
    //   commands.push(new FindMeasureCommand());
    // }

    commands.push(new IncExKeyCmd(Model.getInstance()).find());

    if (commands.length > 0) {
      return new WizGroupCommand().configure(commands, null, false);
    } else {
      return null;
    }
  }

  /**
   * Synchronisation des données
   */
  public wizSynchronizeData(): void {
    // super.managePermissions([ // LMA TODO
    //   {
    //     feature: StaticFeatureEnum.INCEXC,
    //     permissions: [
    //       { component: this.btnAddVision,
    //         accesses: [PermissionAccess.CREATE],
    //         visibility: PermissionVisibility.DISABLED
    //       },
    //       {
    //         component: this.vgDetailZone,
    //         accesses: [PermissionAccess.READ, PermissionAccess.CREATE, PermissionAccess.UPDATE],
    //         visibility: PermissionVisibility.DISABLED
    //       },
    //       {
    //         component: this.btnRemove,
    //         accesses: [PermissionAccess.DELETE],
    //         visibility: PermissionVisibility.DISABLED
    //       }
    //     ]
    //   }
    // ]);

    this.feed();
  }

  /** initialisation et alimentation des contenus */
  private feed(): void {
    this.mainFilter.configure(['code', 'label'], null, null); // alimentation du filtre principal
    this.contentFilter.configure(['code', 'label'], null, null); // alimentation du filtre des contenus
    this.keyFilter.configure(['incStr', 'key', 'label'], null, null); // alimentation du filtre des clés

    this.mainDS.setSource(Model.getInstance().incExcKeyEngine.buildPrecursors()); // alimentation de la liste principale

    this.keyDS.setSource(Model.getInstance().incExcKeyEngine.buildPool()); // alimentation du tableau des clés
    this.globalReset(); // reset global
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.INC_EXC_UPDATE_SAMPLE, null)); // propagation à la popUp
  }

  /** Mise en place des ecouteurs de la vue */
  public wizAddListener(): void {
    WizEventManager.addListener(this, this.contentFilter, WIZ_EVENT_TYPE.CHANGE, this.refreshContent); // application du filtre des contents
    WizEventManager.addListener(this, this.treeContent, ALK_EVENT_TYPE.INC_EXC_ADD_PART, this.addPart); // ajout d'un élément à la clé en cours
    WizEventManager.addListener(this, this.elementRef, ALK_EVENT_TYPE.INC_EXC_DEL_PART, this.delPart); // suppression d'un élément de clé
    WizEventManager.addListener(this, this.mdInc, ALK_EVENT_TYPE.DELETE, this.delKey); // suppression d'une clé
    WizEventManager.addListener(this, this.toggleInc, WIZ_EVENT_TYPE.CHANGE, this.doToggle); // modification inc <=> exc
    WizEventManager.addListener(this, this.trsDesc, WIZ_EVENT_TYPE.MODEL_UPDATE, this.doDescription); // modification de la description

    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.SELECT_VISION, this.feed); // modification de la portée vision au niveau de l'appli, rechargement

    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.INC_EXC_FAST_INC, this.fastKey); // ajout d'une clé depuis le pivot sample
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.INC_EXC_FAST_EXC, this.fastKey); // ajout d'une clé depuis le pivot sample
    WizEventManager.addListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN, this.backFromImport); // Retour de l'import

    // écoute des filtres
    WizEventManager.addListener(this, this.keyFilter, WIZ_EVENT_TYPE.FILTER, () =>
      this.keyDS.refresh()
    );

    WizEventManager.addListener(this, this.mdInc, WIZ_EVENT_TYPE.SELECTION_CHANGING, this.checkSelectKey);
    WizEventManager.addListener(this, this.mdInc, WIZ_EVENT_TYPE.SELECTION_CHANGED, this.selectKey);
  }

  /**
   * Suppression des ecouteurs de la vue
   */
  public wizRemoveListener(): void {
    WizEventManager.removeListener(this, this.contentFilter, WIZ_EVENT_TYPE.CHANGE);
    WizEventManager.removeListener(this, this.treeContent, ALK_EVENT_TYPE.INC_EXC_ADD_PART);
    WizEventManager.removeListener(this, this.elementRef, ALK_EVENT_TYPE.INC_EXC_DEL_PART);
    WizEventManager.removeListener(this, this.mdInc, ALK_EVENT_TYPE.DELETE);
    WizEventManager.removeListener(this, this.toggleInc, WIZ_EVENT_TYPE.CHANGE);
    WizEventManager.removeListener(this, this.trsDesc, WIZ_EVENT_TYPE.MODEL_UPDATE);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.SELECT_VISION);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.INC_EXC_FAST_INC);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.INC_EXC_FAST_EXC);
    WizEventManager.removeListener(this, WizRoot.root(), ALK_EVENT_TYPE.BATCH_IMPORT_RETURN);

    WizEventManager.removeListener(this, this.keyFilter, WIZ_EVENT_TYPE.FILTER);

    WizEventManager.removeListener(this, this.mdInc, WIZ_EVENT_TYPE.SELECTION_CHANGING);
    WizEventManager.removeListener(this, this.mdInc, WIZ_EVENT_TYPE.SELECTION_CHANGED);
  }

  /* #############################################################
                  gestion sélection et filtres
     ############################################################# */

  private mainFilter: FilterComponent; // filterCompo du mdMain
  /** init du filter du mdMain */
  private initMainFilter(pFilter: FilterComponent): FilterComponent {
    this.mainFilter = pFilter;
    return this.mainFilter;
  }

  /**
   * filter de la liste de contenu
   * @param item Elément testé
   */
  private contentFilterFunc(item: IncExcContentObj): boolean {
    return this.contentFilter.checkVisible(item);
  }
  /**
   * application du filtre sur la zone "content"
   * @param e wizEvent
   */
  private refreshContent(e: WizEvent): void {
    this.contentDS.refresh();
  }

  /**
   * filtre des clés
   * @param item Element de la liste testé
   * @returns boolean, true si l'element correspond au filtre, false sinon
   */
   private keyFilterFunc(item: IncExcKeyVO): boolean {
    return this.keyFilter.checkVisible(item);
  }


  /**
   * changement de sélection sur le tableau principal
   * @param e wiZevent, value = IncExcMainObj
   */
  private selectMain(e: WizEvent = null): void {
    // console.log('select main', e.value);
    const mainInc: IncExcMainObj = !!this.mainDS.selectedItems ? this.mainDS.selectedItems[0] : null;
    if (mainInc) {
      this.contentDS.setSource(mainInc.contents);
      this.contentDS.expandAll();
    } else {
      this.contentDS.setSource([]);
    }
  }

  /* #############################################################
                 sélection / création de clé
     ############################################################# */

  /**
   * demande de changement de sélection depuis la collection de keys
   * @param e wizEvent contenant l'item sélectionné
   */
  public checkSelectKey(e: WizEvent = null): void {
    // demande de confirmation lorsqu'un changement est en cours
    if (ViewData.wizUpdateModel) {
      e.preventDefault();

      WizPopUp.confirm(
        '$.common.pending.update.title.$',
        '$.common.pending.update.detail.$',
        this.confirmSelectKey.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        e.value
      ).show();
    }
  }

  /** Confirmation de la sélection de la clé */
  private confirmSelectKey(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      this.keyDS.toggle(result.data); // on a prevent l'event, on joue l'action
      this.selectKey(result.data);
    }
  }

  /**
   * changement de sélection de clé
   * @param e wiZevent, value = IncExcKeyVO
   */
  public selectKey(e: WizEvent = null): void {
    // TODO contrôle préalable si wizmodelUpdate
    if (this.keyDS.selectedItems && this.keyDS.selectedItems.length > 0) {
      Model.getInstance().incExcKeyEngine.currentKey = this.keyDS.selectedItems[0];
      Model.getInstance().incExcKeyEngine.currentClone = Model.getInstance().incExcKeyEngine.clone(Model.getInstance().incExcKeyEngine.currentKey);
    } else {
      
      Model.getInstance().incExcKeyEngine.currentKey = null;
      Model.getInstance().incExcKeyEngine.currentClone = null;
    }
    this.feedKey();
  }

  /** alimentation de la partie IHM "key */
  private feedKey(): void {
    if (!!Model.getInstance().incExcKeyEngine.currentClone) {
      this.currentKeyDS.setSource(Model.getInstance().incExcKeyEngine.currentClone.parts);
      this.toggleInc.wizChecked = !Model.getInstance().incExcKeyEngine.currentClone.inc;

      // alimentation de la description
      this.trsDesc.translationData = Model.getInstance().localeEngine.buildTranslationData(Model.getInstance().incExcKeyEngine.currentClone.descriptionVO);
    } else {
      this.currentKeyDS.setSource([]);
    }
    ViewData.wizUpdateModel = false;
  }

  /** création d'un nouvelle clé inc / exc */
  public newKey(): void {
    if (ViewData.wizUpdateModel) {
      WizPopUp.confirm(
        '$.common.pending.update.title.$',
        '$.common.pending.update.detail.$',
        this.confirmNewKey.bind(this),
        CONFIRMATION_MODE.CONFIRM_CANCEL,
        Model.getInstance().incExcKeyEngine.currentClone
      ).show();
    } else {
      this.confirmNewKey(ConfirmationResultObj.build(CONFIRMATION_RESULT.CONFIRM, null));
    }
  }

  /** Confirmation de la sélection de la clé */
  private confirmNewKey(result: ConfirmationResultObj): void {
    if (result.result === CONFIRMATION_RESULT.CONFIRM) {
      
      if (this.keyDS.selectedItem) {
        this.keyDS.toggle(this.keyDS.selectedItem, false); // on déselectionne l'existant
        this.keyDS.refresh();
      }
      // this.keyDS.clearSelection();
  
      Model.getInstance().incExcKeyEngine.currentKey = new IncExcKeyVO(Model.getInstance());
      Model.getInstance().incExcKeyEngine.currentKey.domain = Model.getInstance().domainCode;
      Model.getInstance().incExcKeyEngine.currentKey.businessUnitCode = Model.getInstance().businessUnitCode;
      Model.getInstance().incExcKeyEngine.currentKey.visionCode = !!Model.getInstance().visionCode
        ? Model.getInstance().visionCode
        : ViewData.wildcardDomain;
      Model.getInstance().incExcKeyEngine.currentClone = Model.getInstance().incExcKeyEngine.clone(Model.getInstance().incExcKeyEngine.currentKey);
      Model.getInstance().incExcKeyEngine.currentClone.inc = !this.toggleInc.wizChecked; // reprise du toggle par défaut
      this.feedKey();

    }
  }

  /** nettoyage sur changement de vision */
  private globalReset(): void {
    this.mainDS.clearSelection();
    this.contentDS.setSource([]);
    this.currentKeyDS.setSource([]);
    this.keyDS.clearSelection();

    Model.getInstance().incExcKeyEngine.currentKey = null;
    Model.getInstance().incExcKeyEngine.currentClone = null;
    // console.log('globalReset', this.hasCurrentKey);
    this.feedKey();
  }

  public doCancel(): void {
    Model.getInstance().incExcKeyEngine.currentClone = Model.getInstance().incExcKeyEngine.clone(Model.getInstance().incExcKeyEngine.currentKey);
    this.feedKey();
  }

  /** modification du toggleswitch */
  private doToggle(e: WizEvent): void {
    Model.getInstance().incExcKeyEngine.currentClone.inc = !(e.component as WizToggle).wizChecked;
    ViewData.wizUpdateModel = true;
  }

  /** modification de la description */
  private doDescription(e: WizEvent): void {
    Model.getInstance().incExcKeyEngine.currentClone.descriptionVO.updateTranslationEntry(e.value);
    ViewData.wizUpdateModel = true;
  }

  /**
   * clic sur le tree, ajout d'un élément
   * @param e AlkEvent, data = IncExcContentObj
   */
  private addPart(e: AlkEvent): void {
    if (!Model.getInstance().incExcKeyEngine.currentClone) { // génération directe depuis le tree
      this.newKey();
    }

    // contrôle de cohérence hiérarchique & unicité
    if (!Model.getInstance().incExcKeyEngine.currentClone.checkParts(e.data as IncExcContentObj)) {
      return;
    }

    Model.getInstance().incExcKeyEngine.currentClone.addPart(e.data);
    this.currentKeyDS.setSource(Model.getInstance().incExcKeyEngine.currentClone.parts);
    ViewData.wizUpdateModel = true;
  }

  /**
   * suppression d'un élément de clé
   * @param e AlkEvent, data = IncExcContentObj
   */
  private delPart(e: AlkEvent): void {
    Model.getInstance().incExcKeyEngine.currentClone.removePart(e.data);
    this.currentKeyDS.refresh();
    ViewData.wizUpdateModel = true;
  }

  /** ajout d'une clé depuis le pivot sample */
  private fastKey(e: AlkEvent): void {
    // console.log('fastKey', e);
    this.newKey();
    const refLine: WidgetLine = (e.data as PivotIncExcRenderer).realLine;
    
    const context: WidgetConfigurationObj = (e.data as PivotIncExcRenderer).pivot.context; // la conf du grid, donne l'ordre des clés
    
    const keyParts: string[] = [];
    const keyVals: string[] = refLine.key.split(ViewData.KEY_SEPARATOR); // les valeurs de la lignes de référence

    context.r.forEach((wcio: WidgetConfigurationItemObj) => {
      keyParts.push(wcio.cod + ViewData.CONTEXT_SEPARATOR + keyVals[wcio.ord]);
    });

    const resultStr = keyParts.join(ViewData.KEY_SEPARATOR);
    Model.getInstance().incExcKeyEngine.currentClone.key = resultStr;
    Model.getInstance().incExcKeyEngine.currentClone.inc = e.type === ALK_EVENT_TYPE.INC_EXC_FAST_INC;
    Model.getInstance().incExcKeyEngine.currentClone.reset(); // génération correct keyMap et label
    Model.getInstance().incExcKeyEngine.save(Model.getInstance().incExcKeyEngine.currentClone, Model.getInstance().incExcKeyEngine.currentKey, this.backFromAdd.bind(this));
  }

  /* #############################################################
                      persistence
     ############################################################# */

  /** enregistrement d'un élément */
  public doSave(): void {
    // TODO créer create et delete si exist
    const existKey: IncExcKeyVO = Model.getInstance().incExcKeyEngine.getIncExcKey(Model.getInstance().incExcKeyEngine.currentClone.uniqueKey);
    if (!!existKey && existKey.id !== Model.getInstance().incExcKeyEngine.currentClone.id) {
      // on est en train de créer un doublon...
      WizPopUp.toast('$.incexc.key.exist.$', WizIcon.TOAST_ERROR).show();
      return;
    }
    Model.getInstance().incExcKeyEngine.save(Model.getInstance().incExcKeyEngine.currentClone, Model.getInstance().incExcKeyEngine.currentKey, this.backFromAdd.bind(this));
  }

  /** synchro sur retour d'enregistrement */
  private backFromAdd(e: IncExcKeyVO) {
    Model.getInstance().incExcKeyEngine.currentKey = null;
    Model.getInstance().incExcKeyEngine.currentClone = null;
    // console.log('backFromAdd', this.hasCurrentKey);
    this.keyDS.clearSelection();
    this.keyDS.refresh(); // c'est le clone
    this.feedKey();

    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.INC_EXC_UPDATE_SAMPLE, e));
  }

  /** suppression d'une clé */
  public delKey(e: AlkEvent): void {
    Model.getInstance().incExcKeyEngine.remove(e.data, this.backFromDelete.bind(this));
  }

  /** synchro sur retour de suppression */
  private backFromDelete(e: IncExcKeyVO) {
    this.keyDS.removeItem(e);
    if (!!Model.getInstance().incExcKeyEngine.currentKey && e.key === Model.getInstance().incExcKeyEngine.currentKey.key) {
      // c'était l'élément en cours
      Model.getInstance().incExcKeyEngine.currentKey = null;
      Model.getInstance().incExcKeyEngine.currentClone = null;
      this.feedKey();
    }
    WizEventManager.dispatchEvent(WizRoot.root(), new AlkEvent(ALK_EVENT_TYPE.INC_EXC_UPDATE_SAMPLE, e));
  }

  /**
   * accesseur sur le panel gauche "sample"
   */
  public rightSideContent(): any {
    return IncExcSamplePop;
  }

  /* ################################################
                      Import / Export
    ################################################ */

  public doAct(action: string): void {
    switch (action) {
      case 'export':
        Model.getInstance().batchEngine.export(BATCH_KIND.INCEXC, BATCH_FILE_FORMAT.CSV, Model.getInstance().visionCode);
        break;
      case 'import':
        Model.getInstance().batchEngine.import(BATCH_KIND.INCEXC);
        break;
    }
  }

  /** callback sur retour d'import : recharger les clés d'inclusion/exclusion */
  private backFromImport(e: AlkEvent): void {
    new IncExKeyCmd(Model.getInstance()).find().configure(this.backFromReload.bind(this)).execute();
  }

  private backFromReload(e: any): void {
    this.wizSynchronizeData();
  } 

}
